import { render, staticRenderFns } from "./Whitelabel.vue?vue&type=template&id=012f02ee&scoped=true"
import script from "./Whitelabel.ts?vue&type=script&lang=ts&external"
export * from "./Whitelabel.ts?vue&type=script&lang=ts&external"
import style0 from "./Whitelabel.scss?vue&type=style&index=0&id=012f02ee&prod&lang=scss&scoped=true&external"
import style1 from "./Whitelabel.vue?vue&type=style&index=1&id=012f02ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f02ee",
  null
  
)

export default component.exports